import { posPlatformNames } from '../consts';

export default function moduleFactory({ module, ...env }) {
    const {
        consts,
        helpers,
        models,
        bridges: {
            webPos,
            wireless,
        },
    } = module;

    webPos.validateEnv && webPos.validateEnv(env);
    wireless.validateEnv && wireless.validateEnv(env);

    return async posPlatform => {
        if (posPlatform.name === posPlatformNames.webPos && webPos.validate)
            webPos.validate(posPlatform, env);
        if (posPlatform.name === posPlatformNames.wireless && wireless.validate)
            wireless.validate(posPlatform, env);

        return {
            [posPlatformNames.webPos]: { 
                ...{ consts, helpers, models },
                ...webPos(posPlatform, env),
            },
            [posPlatformNames.wireless]: { 
                ...{ consts, helpers, models },
                ...wireless(posPlatform, env), 
            }
        }
    }
}
